import React, { useEffect } from "react";
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonItem,
  IonItemDivider,
  IonLabel,
  IonMenuButton,
  IonPage,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import findUsers from "../../store/users/actions/findUsers";
import { KpisSection } from "./components/KpisSection";
import { selectMessages } from "../../store/users/selectors/selectMessages";
import { findMessages } from "../../store/users/actions/findMessages";
import { MessageItem } from "../../components/Message/MessageItem";
import { selectUsers } from "../../store/users/selectors/selectUsers";

export const SettingsPage: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(findUsers());
    dispatch(findMessages());
  }, [dispatch]);

  const messages = useSelector(selectMessages);
  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton color="light"></IonMenuButton>
          </IonButtons>
          <IonTitle>TIC</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense" class="ion-no-border">
          <IonToolbar>
            <IonTitle size="large">TIC</IonTitle>
          </IonToolbar>
        </IonHeader>

        <section className="ion-padding">
          <KpisSection />

          <h2 className="ion-margin-start">
            <IonText color="primary">Actividad</IonText>
          </h2>
        </section>

        <section className="ion-padding-horizontal">
          {Object.entries(messages).length === 0 && (
            <IonItem lines="none">
              <IonLabel>
                <IonText color="medium">No se ha encontrado actividad</IonText>
              </IonLabel>
            </IonItem>
          )}
          {Object.entries(messages).map(([key, value]: any) => (
            <article key={key}>
              <IonItemDivider className="ion-margin-bottom">{key}</IonItemDivider>

              {value.map((messageItem: any) => (
                <MessageItem
                  key={messageItem.id}
                  message={messageItem}
                  routerLink={
                    messageItem.module === "document"
                      ? `/app/rrhh/acuerdos/${messageItem.document?.id}`
                      : messageItem.module === "user"
                        ? `/app/rrhh/usuarios/${messageItem.room}`
                        : ""
                  }
                />
              ))}
            </article>
          ))}
        </section>
      </IonContent>
    </IonPage>
  );
};
